import { VStack } from "@chakra-ui/react"
import React from "react"
import { UpdateZoneForm } from "../../forms"
import { ExtendedZoneFragment } from "../../graphql"

export type UpdateZoneProps = {
	zone: ExtendedZoneFragment
}

export const UpdateZone: React.FC<UpdateZoneProps> = ({ zone }) => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<UpdateZoneForm zone={zone} />
		</VStack>
	)
}
